import Vue from 'vue'
const env = process.env.NODE_ENV

const common = {
  appCode: 'WEBSITE_PC',
  imgOssHost: '' // 阿里云图片服务器
}

// 开发环境：npm run dev
const development = {
  host: '',
  imgHost: 'http://10.0.0.52:9051',
  socketUrl: 'http://10.0.0.52:9229',
  socketUrls: 'https://10.0.0.52:9229',
  webAdmin: 'http://127.0.0.1:3030',
  ...common
}

// 测试环境打包：npm run build test
const test = {
  host: 'http://10.0.0.52:9051',
  socketUrl: 'http://10.0.0.52:9229',
  socketUrls: 'https://10.0.0.52:9229',
  imgHost: 'http://10.0.0.52:9051',
  ...common
}

// 正式环境打包( 准生产 )：npm run build ready
const ready = {
  host: 'http://10.0.0.52:9051',
  imgHost: 'http://10.0.0.52:9051',
  socketUrl: 'http://10.0.0.52:9229',
  socketUrls: 'https://10.0.0.52:9229',
  webAdmin: 'http://10.0.0.22:8083',
  ...common
}

// 正式环境打包：npm run build
const production = {
  host: 'https://api.qcwlyss.com',
  imgHost: 'http://47.107.249.116:9051',
  socketUrl: 'https://websocket.qcwlyss.com',
  socketUrls: 'https://websocket.qcwlyss.com',
  webAdmin: 'http://manage.zhzjcxcy.com',
  ...common
}

const config = {
  development,
  test,
  ready,
  production
}
// Vue.prototype.$config = config[env];
// export default config[env];



// WEBPACK FOOTER //
// ./src/config/index.js